const CARD_SELECTOR = '[data-tilt]';

const MAX_TILT = 1.2;
const LIFT = 3;

const MEDIA = {
    reducedMotion: '(prefers-reduced-motion: reduce)',
    finePointer: '(hover: hover) and (pointer: fine)',
};

export default function SelectedWorkTilt() {
    const cards = Array.from(document.querySelectorAll(CARD_SELECTOR));

    if (!cards.length) {
        return;
    }

    const reducedMotion = window.matchMedia(MEDIA.reducedMotion);
    const finePointer = window.matchMedia(MEDIA.finePointer);

    const allowed = () => !reducedMotion.matches && finePointer.matches;

    const reset = (card) => {
        card.style.transform = '';
    };

    cards.forEach((card) => {
        card.addEventListener('pointermove', (event) => {

            if (!allowed() || event.pointerType !== 'mouse') {
                return;
            }

            const rect = card.getBoundingClientRect();
            const dx = (event.clientX - rect.left) / rect.width - 0.5;
            const dy = (event.clientY - rect.top) / rect.height - 0.5;

            const rotateX = (-dy * 2 * MAX_TILT).toFixed(2);
            const rotateY = (dx * 2 * MAX_TILT).toFixed(2);

            card.style.transform =
                `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-${LIFT}px)`;
        });

        card.addEventListener('pointerleave', () => reset(card));

        card.addEventListener('pointerdown', () => {
            if (allowed()) {
                card.style.transform = 'perspective(900px) scale(0.99)';
            }
        });
    });

    const onChange = () => {
        if (!allowed()) {
            cards.forEach(reset);
        }
    };

    [reducedMotion, finePointer].forEach((query) => {

        if (typeof query.addEventListener === 'function') {
            query.addEventListener('change', onChange);
        } else {
            query.addListener(onChange);
        }
    });
}
